import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import {
  formatDateTimeEnLocaleFromUtc,
  formatRelativeDateTime,
} from '@zorro/shared/formatters';
import { Text } from '@zorro/web/design-system';

type Props = {
  value?: string | null;
  fallback?: string;
  size?: string;
};

/**
 * Renders a timestamp as a relative label ("2 hours ago") with the absolute
 * local time on hover. Reused across the workflow detail view for created /
 * completed / attempt timestamps.
 */
export function TimeDisplay({ value, fallback = '—', size = 'sm' }: Props) {
  if (!value) {
    return (
      <Text component="span" size={size} c="dimmed">
        {fallback}
      </Text>
    );
  }

  return (
    <Tooltip label={formatDateTimeEnLocaleFromUtc(value)} withArrow>
      <Text component="span" size={size}>
        {formatRelativeDateTime(value)}
      </Text>
    </Tooltip>
  );
}
